import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";
import { IRecommendedDevice } from "@/apps/merchant3/types/SelfOnboarding/IRecommendedDevice";

export const getDeviceDetails = (makeModel: string): Promise<AxiosResponse> => {
  return jwtApiClient.get(M3_API(makeModel).PRICING_GET_DEVICE_DETAILS);
};

export const getRecommendedDevices = (
  cartTag: string,
  answerSpecs: string,
  answerPrice: string
): Promise<AxiosResponse<[IRecommendedDevice]>> => {
  return jwtApiClient.get(M3_API(cartTag).GET_RECOMMENDED_DEVICES, {
    params: {
      answerSpecs: answerSpecs,
      answerPrice: answerPrice,
    },
  });
};
